import $ from "jquery"
require('.././less/plugin-uneditable.less')


function FluxEditorUneditable(options={}) {
  this.defaults = {
    identifier: 'flux-editor-uneditable'
  }
  this.settings = Object.assign({}, this.defaults, options)
}

FluxEditorUneditable.prototype.getIdentifier = function () {
  return this.settings.identifier
}

FluxEditorUneditable.prototype.getContent = function (el) {
  return {
    html: el.outerHTML,
  }
}

FluxEditorUneditable.prototype.getHTML = function (content, core) {
  this.___core = core
  return content.html
}

FluxEditorUneditable.prototype.getEditableElement = function (content, core) {
  this.___core = core
  return $('<div><div class="flux-editor-uneditable-mask"></div></div>').append(content.html)
}

export default FluxEditorUneditable
